import {
  LOAN_APPLICATION_FETCH_SUCCESS,
  BUILD_COMMITMENT,
  UPDATE_COMMITMENTS_FAILURE,
  UPDATE_EXPENSE_SUCCESS,
  LOAN_APPLICATION_USER_GOBACK_SUCCESS,
  LOAN_APPLICATION_USER_GOTO_SUCCESS,
} from './../../actions/types'

const allIds = (state = [], {type, payload}) => {
  switch (type) {
    case LOAN_APPLICATION_FETCH_SUCCESS:
      if (payload.applicationFlow.commitments !== undefined) {
        return Object.keys(payload.applicationFlow.commitments)
      } else {
        return state
      }
    case BUILD_COMMITMENT:
      return [...new Set([...state, payload.key])]
    case UPDATE_COMMITMENTS_FAILURE:
      return payload.result || []

    case UPDATE_EXPENSE_SUCCESS:
    case LOAN_APPLICATION_USER_GOTO_SUCCESS:
    case LOAN_APPLICATION_USER_GOBACK_SUCCESS:
      if (payload.commitments !== undefined) {
        return Object.keys(payload.commitments)
      } else {
        return state
      }
    default:
      return state;
  }
}

export default allIds;
